import React from "react";
import styles from "./Sidebar.module.css";
import classNames from "classnames";

type Props = {
  show: boolean;
  children: React.ReactNode;
};
const Sidebar = ({ show, children }: Props) => {
  const classes = classNames(["control-app__sidebar", styles["sidebar"]]);
  return show ? (
    <aside className={classes}>
      {/* <section className={styles["sidebar__top"]}></section>
      <section className={styles["sidebar__bottom"]}>{children}</section> */}
      <div className={styles["sidebar__content"]}>{children}</div>
    </aside>
  ) : (
    <></>
  );
};

export default Sidebar;
